export default "/wp-content/themes/onnit/script/cart/dist/o6ProgramBgRev-12f79a5c.jpg";